/** The column a working list gets instead of the reading width: the window, up to where rows stop reading as one line. */
export const WIDE_CONTENT = { maxWidth: 1400, sidePadding: 18 };
